import React, { useState, useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AsyncSelect from 'react-select/async';

import Header from '../../components/Header';

// Actions
import { gameActions } from '../../actions';

// Inline component

// Select with search functionality
// Input with search functionality, after typing 3 characters call the API

const New = () => {
  // State
  const [state, setState] = useState({
    instructors: [],
    name: '',
    instructor: null,
    type: 'csv',
  });

  // Hooks
  const user = useSelector((state) => state.authentication.user);
  const game = useSelector((state) => state.game);
  const dispatch = useDispatch();

  // Logic
  const { name, instructor, instructors, type } = state;

  // Effects
  useEffect(() => {
    // if (user.role === 'administrator') {
    //   hubGetUsers();
    // } else {
    //   setState((prev) => ({
    //     ...prev,
    //     instructors: [user],
    //     instructor: user._id,
    //   }));
    // }
    setState((prev) => ({
      ...prev,
      instructors: [instructorDataToOption(user)],
      instructor: instructorDataToOption(user),
    }));
  }, [user]);

  // If there's game data, then Navigate to it
  useEffect(() => {
    if (game.data) {
      setState((prev) => ({
        ...prev,
        data: game.data,
      }));
    }
  }, [game.data]);

  // Methods
  const handleChange = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const setType = (newType) => {
    setState((prev) => ({
      ...prev,
      type: newType,
    }));
  };

  const sortByName = (a, b) => {
    const fullNameEmailA = `${a.name} ${a.lastname} ${a.email}`
      ?.trim()
      .toLowerCase();
    const fullNameEmailB = `${b.name} ${b.lastname} ${b.email}`
      ?.trim()
      .toLowerCase();
    if (fullNameEmailA < fullNameEmailB) return -1;
    if (fullNameEmailA > fullNameEmailB) return 1;
    return 0;
  };

  const instructorDataToOption = (i) => {
    if (!i) return null;

    // Map the data to the format required by react-select
    const name =
      i?.name?.length > 0 || i?.lastname?.length > 0
        ? `${i?.name} ${i?.lastname} (${i.email})`.trim()
        : i?.email;

    return {
      value: i._id,
      label: `${name}`?.trim(),
    };
  };

  const hubGetFilteredUsers = async (inputValue) => {
    // Only proceed if inputValue is at least 3 characters long
    if (inputValue.length < 3) return [];

    // Define filters
    const queryString = `?role[]=instructor&role[]=administrator&email=${inputValue}`;
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/hub/users${queryString}`,
      {
        method: 'GET',
      }
    );
    const data = await response.json();

    const sortedData = data?.sort(sortByName)?.map(instructorDataToOption);
    setState((prev) => ({
      ...prev,
      instructors: sortedData,
    }));

    return sortedData;
  };

  const submit = () => {
    const data = {
      name: state.name,
      instructor: state.instructor?.value,
      access_type: state.type,
    };
    dispatch(gameActions.createGame(data));
  };

  // If there's game data, then Navigate to it
  if (game.data && game.data._id)
    return <Navigate to={`/games/${game.data._id}`} />;

  const canSubmit =
    name.length > 0 && type.length > 0 && instructor?.value?.length > 0;

  return (
    <div className=''>
      <Header />

      <h2 className='mt-3 sec-title fs-3'>New Game</h2>

      <div className='row mt-4'>
        <div className='col-12 col-md-8 offset-md-2'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='input-group input-group-lg'>
                <input
                  name='name'
                  className='form-control'
                  onChange={handleChange}
                  placeholder='Enter Game Name (Required)'
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className='input-group input-group-lg'>
                {/* For Instructors */}
                {user?.role === 'instructor' && (
                  <select
                    name='instructor'
                    className='form-control form-select'
                    value={instructor?._id}
                    onChange={handleChange}
                    disabled={user.role === 'instructor'}>
                    <option value=''>Select Instructor (Required)</option>
                    {instructors?.map((instructor) => (
                      <option key={instructor._id} value={instructor._id}>
                        {`${instructor.name} ${instructor.lastname} (${instructor.email})`}
                      </option>
                    ))}
                  </select>
                )}

                {/* For Admins */}
                {['administrator', 'manager'].includes(user?.role) && (
                  <AsyncSelect
                    name='instructor'
                    classNamePrefix='react-select'
                    classNames={{
                      container: () => 'fs-5 w-100',
                      input: () => 'py-1',
                      control: () => 'px-2 border rounded-3',
                      indicatorSeparator: () => 'my-3',
                      menu: () => 'small',
                    }}
                    loadOptions={hubGetFilteredUsers}
                    onChange={(selectedOption) => {
                      setState((prev) => ({
                        ...prev,
                        instructor: selectedOption,
                      }));
                    }}
                    // options={instructors}
                    defaultOptions={state.instructors}
                    value={instructor}
                    placeholder='Search Instructor'
                    noOptionsMessage={() => 'No instructors found'}
                    isClearable
                    isSearchable
                  />
                )}
              </div>
            </div>
          </div>
          <div className='row mt-4 mb-5'>
            <div className='col-12 text-center lead mb-3'>
              Review how you add students below:
            </div>

            <div className='col-6'>
              <div
                className={
                  'card h-100 card-selectable ' +
                  (type === 'link' ? 'selected' : '')
                }
                onClick={() => setType('link')}>
                <div className='card-body'>
                  <h5>EMAIL + LINK</h5>

                  <b>Instructor/Admin:</b>
                  <ul>
                    <li>Display registration link</li>
                  </ul>

                  <b>Student Process:</b>
                  <ul>
                    <li>Register via link</li>
                    <li>Check email</li>
                    <li>Login to platform</li>
                    <li>Click on invitation</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-6'>
              <div
                className={
                  'card h-100 card-selectable ' +
                  (type === 'csv' ? 'selected' : '')
                }
                onClick={() => setType('csv')}>
                <div className='card-body'>
                  <h5>CSV</h5>

                  <b>Instructor/Admin:</b>
                  <ul>
                    <li>Upload class list</li>
                  </ul>

                  <b>Student Process:</b>
                  <ul>
                    <li>Check email</li>
                    <li>Login to platform</li>
                    <li>Click on invitation</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='text-center col-12 mt-5'>
              <Link to='/games' className='btn btn-light btn-lg me-2'>
                Cancel
              </Link>
              <button
                className='btn btn-outline-primary btn-lg ms-2'
                disabled={!canSubmit}
                onClick={submit}>
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { New as GameNew };
